module.exports = __webpack_public_path__ + "img/receipt15.9557c60d.png";